import { create } from "zustand";
import { ChequeSelectorItem, UpdateFn } from "../../../types";

interface State {
  selectedCheques: Array<ChequeSelectorItem>;
}

interface Action {
  setSelectedCheques: UpdateFn<Array<ChequeSelectorItem>>;
}

const useSpendFactorStore = create<State & Action>((set) => ({
  selectedCheques: [],
  setSelectedCheques: (updater) => {
    if (typeof updater === "object") {
      set({ selectedCheques: updater });
    } else {
      set((state) => ({ selectedCheques: updater(state.selectedCheques) }));
    }
  },
}));

export default useSpendFactorStore;
